import React from 'react';
import moment from 'moment';
import {
	ApSimpleTable,
	ApSimpleTableHead,
	ApSimpleTableRow,
	ApSimpleTableHeadCell,
	ApSimpleTableBody,
	ApSimpleTableBodyCell,
} from '@alixpartners/ui-components';

import { SimpleTableRow } from './styles';

const FILE_TYPES = {
	unknown: 0,
	spendcubeByVendor: 1,
	spendcubeVendorTransactions: 2,
	unclassifiedSpendcube: 4,
};

const FILE_TYPES_TABLE_TEXT = {
	[FILE_TYPES.unknown]: '',
	[FILE_TYPES.spendcubeByVendor]: 'Spendcube by Vendor',
	[FILE_TYPES.spendcubeVendorTransactions]: 'Spendcube Vendor Transactions',
	[FILE_TYPES.unclassifiedSpendcube]: 'Unclassified Spendcube',
};

export const FileArchiveTable = props => {
	const { data } = props;

	const getFormattedDate = date => {
		const formattedDate = moment(date, moment.ISO_8601);
		return formattedDate.format('MMMM Do, h:mm a');
	};

	return (
		<React.Fragment>
			<ApSimpleTable
				tableBorders={{
					top: true,
					left: true,
					right: true,
					bottom: true,
				}}
				tableHeight="100%"
			>
				<ApSimpleTableHead>
					<ApSimpleTableRow>
						<ApSimpleTableHeadCell>File name</ApSimpleTableHeadCell>
						<ApSimpleTableHeadCell>Type</ApSimpleTableHeadCell>
						<ApSimpleTableHeadCell>Consultant name</ApSimpleTableHeadCell>
						<ApSimpleTableHeadCell>Date</ApSimpleTableHeadCell>
					</ApSimpleTableRow>
				</ApSimpleTableHead>
				<ApSimpleTableBody>
					{data.map((row, index) => {
						return (
							<SimpleTableRow key={index}>
								<ApSimpleTableBodyCell
									cellBorders={{
										left: false,
										bottom: true,
										right: true,
									}}
								>
									{row.fileName}
								</ApSimpleTableBodyCell>
								<ApSimpleTableBodyCell
									cellBorders={{
										left: false,
										bottom: true,
										right: true,
									}}
								>
									{
										FILE_TYPES_TABLE_TEXT[
											(row.fileType && row.fileType.value) || FILE_TYPES.unknown
										]
									}
								</ApSimpleTableBodyCell>
								<ApSimpleTableBodyCell
									cellBorders={{
										left: true,
										bottom: true,
										right: true,
									}}
								>
									{row.userName}
								</ApSimpleTableBodyCell>
								<ApSimpleTableBodyCell
									cellBorders={{
										left: true,
										bottom: true,
										right: true,
									}}
								>
									{getFormattedDate(row.date)}
								</ApSimpleTableBodyCell>
							</SimpleTableRow>
						);
					})}
				</ApSimpleTableBody>
			</ApSimpleTable>
		</React.Fragment>
	);
};
